import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import IssuedStake from './IssuedStake';
import LiveStake from './LiveStake';
import RequestCancelStake from './RequestCancelStake';
import ViewStake from './ViewStake';
import ClaimedStake from './ClaimedStake';
import { STATUS } from '../../utils/status';

// is Loading - don't re-rerender?
class ViewStakeContainer extends Component {

  // increaseBalance = (userId, profit) => {
  //   const user = this.props.users.find(x => x.user_id === userId);
  //   const currentBalance = user ? user.app_metadata.balance : this.props.availableBalance;
  //   updateUserBalanceAction(currentBalance + profit);
  // }

  render() {
    const { allStakes, user, match, test } = this.props;
    const stake = allStakes.find(x => x.id === match.params.stakeId) || test;

    if (!stake) return <Redirect to="/" />;

    switch (stake.status) {
      case STATUS.Staked:
      case STATUS.Reissued:
        return <IssuedStake stake={stake} allStakes={allStakes} />;
      case STATUS.Live:
        return <LiveStake stake={stake} />;
      case STATUS.RequestCancel:
        return <RequestCancelStake stake={stake} user={user} />;
      case STATUS.Claimed:
        return <ClaimedStake stake={stake} user={user} />;
      default:
        return <ViewStake stake={stake} />;
    }
  }
}

const mapStateToProps = ({ app, auth }) => ({
  allStakes: [...app.myStakes, ...app.challengedStakes],
  user: auth.profile
});

export default connect(mapStateToProps)(ViewStakeContainer);



// WEBPACK FOOTER //
// ./src/App/ViewStake/ViewStakeContainer.js